import React, { useEffect, useState } from "react";
import backgroundImage from "../assets/bg-image.png";
import CustomButton from "./CustomButton";
// import { fetchContent } from "../services/api";
import Qrcodegenerator from "./QRCodeGenerator";
import LoginPage from "./LoginPage";
import logoimg from "../assets/loginLogo.png";
import LoginOTP from "./LoginOTP";
import { Translate } from "./LanguageChanger";
import background_img from "../assets/background_img.png";
import RefferalPopup from "./RefferalPopup";
import RefferalCode from "../assets/refferalcode.png";
import { applyReferral } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { event } from "jquery";

let selectedElementIndx = 0;
let resolution = window.RESOLUTION;

const LoginScreen = ({ navigate }) => {
  const [state, setState] = useState({
    isLoginSelected: true,
    isSkipLoginSelected: false,
    shouldShowError: false,
    isRefferalFocus: false,
    // isRefferalSelected: false,
    selectedElementIndxNumeric: "",
    isMobile: true,
    isEmail: false,
    errTitle: "",
    inputValue: "", // To store the API response value for the input
    errorMessage: "", // To store the error message
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
    referralSuccess: "",
    shouldShowRefError: false,
  });

  const {
    isMobileSelected,
    isEmailSelected,
    isproceedSelected,
    isSkipLoginSelected,
    isMobileNoSelected,
    isEmailidSelected,
    isDonePressed,
    isEmail,
    isMobile,
    errorMessage,
    shouldShowError,
    isRefferalFocus,
    // isRefferalSelected,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    referralSuccess,
    shouldShowRefError,
  } = state;
  const [refferalInput, setRefferalInput] = useState("");

  const [loginData, setLoginData] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [referralClick, setReferralClick] = useState(false);

  const navigateToScreen = (screen = {}) => {
    navigate(screen);
  };

  const backgroundStyle = {
    // backgroundImage: `url(${background_img})`,
    backgroundColor: "#000037",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    minHeight: "100vh",
    // width: "100vw",
    // height: "100vh",
    height: "1080px",
  };

  const handleRefferal = () => {
    window.isRefferalSelected = true;
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowError: true,
      errTitle: "Referral Code",
      errDescription: "ExitMsg",
      errIcon: RefferalCode,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Apply", "Cancel"],
    }));
    // MenuScreen.SetFocus(true);
  };

  const logobox = {
    backgroundImage: `url(${logoimg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    width: "115px",
    height: "94px",
    position: "relative",
    marginLeft: "44%",
    top: "2rem",
  };

  const layertransparent = {
    width: "100%",
    height: "100%",
    backgroundImage: `url(${background_img})`,
    // backgroundColor: "#000037",
    // background: "#000",
    opacity: "1",
    position: "absolute",
  };

  const languageselection = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "80%",
    // height: "1080px",
    // backgroundColor: "#000037",
    // backgroundColor: "#000",
    color: "#fff",
    width: "90%",
    margin: "5vh auto",
  };

  const languagegrid = {
    // border: "1px solid red",
    width: "100%",
    display: "flex",
    // gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
    position: "relative",
    bottom: "6rem",
  };

  const languagesymbol = {
    fontSize: "2rem",
    marginBottom: "0.5rem",
  };

  const languagename = {
    fontSize: "1.2rem",
  };

  const applanguage = {
    fontFamily: "Anek Latin",
    fontWeight: "700",
    textAlign: "center",
    fontSize: "48px",
    // marginBottom: "1rem",
    marginTop: "10rem",
    // zIndex: 9999999,
    marginRight: "5%",
  };

  const preferredlanguage = {
    fontSize: "1.5rem",
    marginBottom: "2rem",
  };

  const languagenameicon = {
    fontSize: "0.9rem",
  };

  const languagebutton = {
    width: "34vh",
    height: "19vh",
    borderWidth: "1px 1px 0px 1px" /* top, right, bottom, left */,
    borderStyle: "solid",
    borderCcolor: "grey",
    padding: "1rem",
    borderRadius: "1rem",
  };

  const languageicon = {
    float: "right",
    position: "relative",
    top: "38px",
  };

  const leftContainer = {
    width: "66vh",
  };

  const rightContainer = {
    width: "50%",
    // width: "80vh",
    height: "85vh",
    display: "flex",
    flexDirection: "column",
  };

  const styles = {
    welcomeContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      color: "#333",
      fontSize: "1.5em",
      // backgroundImage: "url(./assets/welcomebg.png)",
      backgroundSize: "cover",
      backgroundPosition: "center", // Center the background image
      backgroundRepeat: "no-repeat", // Do not repeat the background image
      overflow: "hidden",
    },
  };

  const dividercontainer = {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    margin: "62px 0px 0px 17px",
    height: "60%",
    marginTop:"10%",
  };

  const dividerline = {
    flexGrow: "1",
    height: "20vh",
    backgroundColor: "rgba(193, 193, 193, 1)",
    width: "2px",
  };

  const dividertext = {
    margin: "0 10px",
    color: "#fff",
    fontWeight: 500,
    padding: "20px",
    fontFamily: "Anek Latin",
    fontSize: "28px",
  };

  const { isLogedInUser, loading, qrtokendata, griddata, shouldFocusToGrid } =
    state;
  let hasFetchedData = false;
  let isGridCalled = true;

  // const loadData = async () => {
  //   if (hasFetchedData) return;
  //   hasFetchedData = true;
  //   if (!isGridCalled) return;

  //   let headers = {
  //     iskid: "0",
  //     Langid: "1",
  //     "Content-Type": "application/json",
  //   };

  //   try {
  //     // Fetch banner and grid data simultaneously
  //     const [fetchQRData, fetchedQRData] = await Promise.all([
  //       fetchContent("/V1/generateQrToken", "GET", headers),
  //       // fetchContent("/V1/getHomeContent", "GET", headers),
  //     ]);
  //     console.log(fetchQRData, fetchedQRData);
  //     isGridCalled = false;

  //     // Update state with both banner and grid data
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       qrtokendata: fetchQRData.data.qr_token,
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //     }));
  //     isGridCalled = false;
  //   }
  // };

  const handleLeft = () => {
    console.log("handleBack...");
    setLoginData(true);
  };

  const handleRight = () => {
    console.log("handleRight...");
    setLoginData(false);
  };

  const handleLeftInput = () => {
    console.log("handleLeftInput...");
    setState((prevState) => ({
      ...prevState,
      shouldShowError: false,
    }));
  };

  const handleRightInput = () => {
    console.log("handleRightInput...");
  };

  const loadData = async () => {
    console.log("loadData...", refferalInput);

    const referalCode = localStorage.getItem("refferalCodeNumber");
    const getCountry = localStorage.getItem("country");

    const myHeaders = {
      Version: localStorage.getItem("version"),
      Deviceid: localStorage.getItem("macAddress"),
      Devicetoken: localStorage.getItem("uuid"),
      Devicemodel: localStorage.getItem("modelCode"),
      country: getCountry,
      "Content-Type": "application/json",
    };

    const raw = {
      refral_code: referalCode,
    };

    const body = JSON.stringify(raw);

    try {
      const response = await applyReferral(body);
      console.log("response", response, raw);

      if (response.status === true) {
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            referralSuccess: true,
            shouldShowRefError: false,
            shouldShowError: false,
            isMobileSelected: true,
            isRefferalFocus: false,
          }));
          window.isRefferalSelected = false;
          window.isRefferalFocus = false;
        }, 100);

        sendReferalEvent("Valid",referalCode);
      } else {
        console.log("response.status...", response.status);
        setState((prevState) => ({
          ...prevState,
          referralSuccess: false,
          shouldShowError: true,
          shouldShowRefError: true,
        }));

        sendReferalEvent("Invalid", referalCode);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const sendReferalEvent =  (action, referalCode) => {
    sendTestMatomoEvent({
      eventCategory: "ReferralCodePopup",
      eventAction: "CodeStatus",
      eventName: `${referalCode}/${action}`,
    });
  };

  const modalOKButtonHandler = (action) => {
    let Logout = action?.props?.langKey;

    switch (Logout ? Logout : action) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Apply":
        window.isRefferalFocus = false;
        loadData();
        // localStorage.removeItem("JWTToken");
        // localStorage.removeItem("userInfo");
        // const getCountry = localStorage.getItem("country");
        // let headers = {
        //   Version: "1.0",
        //
        //   Deviceid: "0",
        //   Devicetoken: "0",
        //   Devicemodel: "0",
        //   iskid: "0",
        //   Langid: "1",
        //   "Content-Type": "application/json",
        //   country: getCountry,
        // };
        // body {
        //   "refral_code": "string";
        // }
        // Promise.all([fetchContent("/V1/applyRefral", "POST", headers)]);
        break;
      default:
        break;
    }
  };

  const handleCancel = () => {
    console.log("modalCANCELButtonHandler...", window.isRefferalSelected);
    // MenuScreen.ReseTfocus(5);
    // MenuScreen.ReseTfocus(-1);
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        shouldShowError: false,
        isRefferalFocus: false,
        // isRefferalSelected: true,
        shouldShowRefError: false,
        // isMobile: true,
        // isMobileSelected: true,
      }));
      window.isRefferalSelected = false;
      window.isRefferalFocus = false;
    }, 100);
    console.log("isRefferalSelected...", window.isRefferalSelected);
  };

  const referralFocus = () => {
    console.log("isRefferalSelected...");
  };

  const handleApplyOk = () => {
    console.log("handleApplyOk...");
    if (
      localStorage.getItem("refferalCodeNumber") !== null &&
      localStorage.getItem("refferalCodeNumber") !== ""
    ) {
      //    setTimeout(() => {
      // setState((prevState) => ({
      //   ...prevState,
      //   shouldShowError: false,
      //   isRefferalFocus: true,
      //   // isRefferalSelected: true,
      //   shouldShowRefError: false,
      //   // isMobile: true,
      //   // isMobileSelected: true,
      // }));
      // window. isRefferalSelected = false
      // window.isRefferalFocus = false;
      // }, 100);
      // window.isRefferalFocus = false;
      // window.isRefferalSelected = false;

      loadData();
      // setState((prevState) => ({
      //   ...prevState,
      //   shouldShowError: false,
      //   // isMobile: true,
      // }));
    } else {
      setState((prevState) => ({
        ...prevState,
        shouldShowError: true,
        shouldShowRefError: true,
        // errTitle: "Referral Code",
        // errDescription: "Please enter a valid referral code.",
        // errIcon: RefferalCode,
        // iconWdth: "109px",
        // iconHeight: "109px",
        // button: ["OK", "Cancel"],
      }));
    }
  };

  const handleRefferalClick = () => {
    // console.log("first")
    setReferralClick(true);
  };

  return (
    <div style={backgroundStyle}>
      <div style={layertransparent}>
        <div style={logobox}></div>
        <div style={languageselection}>
          <h1 style={applanguage}>
            <Translate langKey={"welcome_to_dds_world_of_entertainment"} />
          </h1>
          <div style={languagegrid}>
            <div style={leftContainer}>
              <Qrcodegenerator
                navigate={navigateToScreen}
                loginData={loginData}
                handleRight={handleRight}
                isExpired={isExpired}
                setIsExpired={setIsExpired}
              />
            </div>
            <div style={dividercontainer}>
              <div style={dividerline}></div>
              <span style={dividertext}>
                <Translate langKey={"or"} />
              </span>
              <div style={dividerline}></div>
            </div>
            <div style={rightContainer}>
              <LoginPage
                navigate={navigateToScreen}
                loginData={loginData}
                handleLeft={handleLeft}
                handleRight={handleRight}
                isExpired={isExpired}
                handleRefferal={handleRefferal}
                state={state}
                setState={setState}
                handleCancel={handleCancel}
                modalOKButtonHandler={modalOKButtonHandler}
                referralSuccess={referralSuccess}
                shouldShowRefError={shouldShowRefError}
                referralFocus={referralFocus}
                handleRefferalClick={handleRefferalClick}
              />
              {/* <LoginOTP /> */}
            </div>
            {/* <div style={{position: "relative", zIndex:"99"}}> */}
            {/* <RefferalPopup
                      shouldShowError={shouldShowError}
                      errTitle={errTitle}
                      errDescription={errDescription}
                      errIcon={errIcon}
                      button={button}
                      iconWdth={iconWdth}
                      iconHeight={iconHeight}
                      // handleRefferal={handleRefferal}
                      // modalOKButtonHandler={modalOKButtonHandler}
                      // modalCANCELButtonHandler={modalCANCELButtonHandler}
                    /> */}
            {/* </div> */}
          </div>
        </div>
        <RefferalPopup
          shouldShowError={shouldShowError}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          handleLeftInput={handleLeftInput}
          handleRightInput={handleRightInput}
          handleCancel={handleCancel}
          handleApplyOk={handleApplyOk}
          // handleRefferal={handleRefferal}
          modalOKButtonHandler={modalOKButtonHandler}
          state={state}
          setState={setState}
          referralSuccess={referralSuccess}
          shouldShowRefError={shouldShowRefError}
          referralClick={referralClick}
          // isRefferalSelected={isRefferalSelected}
          // modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>
    </div>
  );
};

export default LoginScreen;
